<main>
  <h1 class="as-font">
    <a [routerLink]="['']"
      ><mat-label>{{ 'FILTER.init' | translate }} </mat-label>
    </a>
    >
    <span class="as-font-green as-font-semibold">{{
      'FILTER.allDepartments' | translate
    }}</span>
  </h1>
  <section>
    <div
      *ngIf="loading; else showDepartments"
      class="as-spinner-green spinner as-row as-justify-center as-align-center"
    >
      <mat-spinner [diameter]="100"></mat-spinner>
    </div>
    <ng-template #showDepartments>
      <div *ngFor="let department of departments; let last = last">
        <a [routerLink]="[department.department_url]">
          <mat-label
            class="as-font as-font-semibold as-font-black-gray as-font-20"
            >{{ department.description }}</mat-label
          >
        </a>
        <div class="as-categories as-mt-20">
          <div *ngFor="let category of department.categories">
            <a
              [routerLink]="[department.department_url]"
              [queryParams]="{ category: category.category_name }"
            >
              <mat-label
                class="as-font as-font-normal as-font-gray-75 as-font-14"
                >{{ category.category_name }}</mat-label
              >
            </a>
          </div>
        </div>
        <mat-divider class="as-mt-20" *ngIf="!last"></mat-divider>
      </div>
    </ng-template>
  </section>
</main>
